// Enhanced Custom Card Air Fryer Navigation with Auto-Scrolling
document.addEventListener('DOMContentLoaded', function() {
  const sliderTrack = document.querySelector('.airfryer-slider-track');
  const prevButton = document.querySelector('.airfryer-nav-prev');
  const nextButton = document.querySelector('.airfryer-nav-next');
  
  if (!sliderTrack || !prevButton || !nextButton) return;
  
  // Ensure enhanced smooth scrolling behavior with optimized CSS
  sliderTrack.style.scrollBehavior = 'smooth';
  sliderTrack.style.scrollSnapType = 'x mandatory';
  
  // Add optimized CSS for smoother transitions
  const style = document.createElement('style');
  style.textContent = `
    .airfryer-slider-track {
      scroll-behavior: smooth !important;
      transition: scroll-left 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    }
    .airfryer-slider-slide {
      scroll-snap-align: start;
    }
  `;
  document.head.appendChild(style);
  
  // Auto-scroll configuration
  let autoScrollInterval;
  let isUserInteracting = false;
  let interactionTimeout;
  const autoScrollDelay = getAutoScrollDelay();
  
  // Get auto-scroll delay based on screen size - optimized for speed
  function getAutoScrollDelay() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 749) {
      return 3500; // 3.5 seconds on mobile - faster
    } else if (screenWidth <= 1200) {
      return 3000; // 3 seconds on tablet - faster
    } else {
      return 2500; // 2.5 seconds on desktop - faster
    }
  }
  
  // Calculate scroll amount based on card width + gap
  function getScrollAmount() {
    const firstCard = sliderTrack.querySelector('.airfryer-slider-slide');
    if (!firstCard) return 300;
    
    const cardWidth = firstCard.offsetWidth;
    const screenWidth = window.innerWidth;
    
    // Adjust gap based on screen size
    let gap = 20;
    if (screenWidth <= 749) {
      gap = 20; // Mobile gap - matches CSS
    } else if (screenWidth <= 1200) {
      gap = 25; // Tablet gap
    } else {
      gap = 30; // Desktop gap
    }
    
    // For mobile, scroll by full card width to show complete cards
    if (screenWidth <= 749) {
      return cardWidth + gap;
    }
    
    return cardWidth + gap;
  }
  
  // Update arrow states based on scroll position
  function updateArrowStates() {
    const scrollLeft = sliderTrack.scrollLeft;
    const maxScroll = sliderTrack.scrollWidth - sliderTrack.clientWidth;
    
    // Update prev button
    prevButton.disabled = scrollLeft <= 0;
    
    // Update next button
    nextButton.disabled = scrollLeft >= maxScroll - 1; // -1 for rounding errors
  }
  
  // Handle previous button click
  prevButton.addEventListener('click', function() {
    pauseAutoScroll();
    const scrollAmount = getScrollAmount();
    sliderTrack.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  });
  
  // Handle next button click
  nextButton.addEventListener('click', function() {
    pauseAutoScroll();
    const scrollAmount = getScrollAmount();
    sliderTrack.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  });
  
  // Auto-scroll functions
  function startAutoScroll() {
    if (autoScrollInterval) return;
    
    autoScrollInterval = setInterval(() => {
      if (isUserInteracting) return;
      
      const scrollAmount = getScrollAmount();
      const maxScroll = sliderTrack.scrollWidth - sliderTrack.clientWidth;
      
      // Check if we've reached the end
      if (sliderTrack.scrollLeft >= maxScroll - 1) {
        // Reset to beginning for continuous loop
        sliderTrack.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      } else {
        // Scroll to next card
        sliderTrack.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    }, autoScrollDelay);
    
    console.log('Custom Card Air Fryer: Auto-scroll started');
  }
  
  function stopAutoScroll() {
    if (autoScrollInterval) {
      clearInterval(autoScrollInterval);
      autoScrollInterval = null;
      console.log('Custom Card Air Fryer: Auto-scroll stopped');
    }
  }
  
  function pauseAutoScroll() {
    if (!isUserInteracting) {
      isUserInteracting = true;
      stopAutoScroll();
      console.log('Custom Card Air Fryer: Auto-scroll paused (user interaction)');
    }
    
    // Clear existing timeout
    clearTimeout(interactionTimeout);
    
    // Resume auto-scroll after 4 seconds of no interaction - faster resume
    interactionTimeout = setTimeout(() => {
      isUserInteracting = false;
      startAutoScroll();
      console.log('Custom Card Air Fryer: Auto-scroll resumed');
    }, 4000);
  }
  
  // Update arrow states on resize
  window.addEventListener('resize', function() {
    setTimeout(updateArrowStates, 100);
  });
  
  // Initial arrow state update
  setTimeout(updateArrowStates, 100);
  
  // Enhanced touch/swipe support for mobile
  let startX = 0;
  let scrollStart = 0;
  let isScrolling = false;
  
  sliderTrack.addEventListener('touchstart', function(e) {
    pauseAutoScroll();
    startX = e.touches[0].clientX;
    scrollStart = sliderTrack.scrollLeft;
    isScrolling = true;
    sliderTrack.style.scrollBehavior = 'auto'; // Disable smooth scroll during touch
  }, { passive: true });
  
  sliderTrack.addEventListener('touchmove', function(e) {
    if (!isScrolling) return;
    
    const currentX = e.touches[0].clientX;
    const diff = startX - currentX;
    sliderTrack.scrollLeft = scrollStart + diff;
  }, { passive: true });
  
  sliderTrack.addEventListener('touchend', function() {
    isScrolling = false;
    sliderTrack.style.scrollBehavior = 'smooth'; // Re-enable smooth scroll
    updateArrowStates(); // Update arrow states after touch
  });
  
  // Debug function for mobile
  function debugMobileScroll() {
    if (window.innerWidth <= 749) {
      console.log('Mobile Debug:', {
        containerWidth: sliderTrack.offsetWidth,
        scrollWidth: sliderTrack.scrollWidth,
        scrollLeft: sliderTrack.scrollLeft,
        canScroll: sliderTrack.scrollWidth > sliderTrack.offsetWidth
      });
    }
  }
  
  // Add debug on scroll for mobile
  sliderTrack.addEventListener('scroll', function() {
    updateArrowStates();
    if (window.innerWidth <= 749) {
      debugMobileScroll();
    }
  });
  
  // Hover interactions for auto-scroll
  const sliderContainer = document.querySelector('.airfryer-slider-container');
  if (sliderContainer) {
    sliderContainer.addEventListener('mouseenter', function() {
      stopAutoScroll();
    });
    
    sliderContainer.addEventListener('mouseleave', function() {
      if (!isUserInteracting) {
        startAutoScroll();
      }
    });
  }
  
  // Keyboard navigation
  sliderTrack.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      pauseAutoScroll();
    }
  });
  
  // Initialize auto-scroll and visual indicator
  initCustomCardAutoScroll(startAutoScroll, stopAutoScroll);
  addCustomCardProgressIndicator(startAutoScroll, stopAutoScroll);
  
  console.log('Custom Card Air Fryer: Auto-scroll initialized');
});

/**
 * Initialize auto-scroll with intersection observer
 */
function initCustomCardAutoScroll(startFn, stopFn) {
  const sliderContainer = document.querySelector('.airfryer-slider-container');
  if (!sliderContainer) return;
  
  // Start auto-scroll initially - faster initialization
  setTimeout(() => {
    startFn();
  }, 500);
  
  // Intersection Observer for performance
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const sliderTrack = document.querySelector('.airfryer-slider-track');
        if (!sliderTrack) return;
        
        if (entry.isIntersecting) {
          const isUserInteracting = sliderTrack.dataset.userInteracting === 'true';
          if (!isUserInteracting) {
            startFn();
          }
          console.log('Custom Card Air Fryer: In viewport - auto-scroll active');
        } else {
          stopFn();
          console.log('Custom Card Air Fryer: Out of viewport - auto-scroll paused');
        }
      });
    }, {
      threshold: 0.3,
      rootMargin: '50px'
    });
    
    observer.observe(sliderContainer);
  }
}

/**
 * Add visual progress indicator
 */
function addCustomCardProgressIndicator(startFn, stopFn) {
  const sliderContainer = document.querySelector('.airfryer-slider-container');
  if (!sliderContainer) return;
  
  // Create progress bar
  const progressBar = document.createElement('div');
  progressBar.className = 'custom-card-auto-scroll-progress';
  progressBar.innerHTML = '<div class="custom-card-progress-fill"></div>';
  
  // Add CSS for progress bar
  const style = document.createElement('style');
  style.textContent = `
    .custom-card-auto-scroll-progress {
      position: absolute;
      bottom: -18px;
      left: 50%;
      transform: translateX(-50%);
      width: 75px;
      height: 2px;
      background: rgba(119, 53, 40, 0.2);
      border-radius: 1px;
      overflow: hidden;
      z-index: 10;
    }
    
    .custom-card-progress-fill {
      height: 100%;
      background: #773528;
      width: 0%;
      border-radius: 1px;
      transition: width 0.1s linear;
    }
    
    .custom-card-auto-scroll-progress.paused .custom-card-progress-fill {
      animation-play-state: paused;
    }
    
    @media screen and (max-width: 768px) {
      .custom-card-auto-scroll-progress {
        bottom: -22px;
        width: 65px;
      }
    }
  `;
  
  document.head.appendChild(style);
  sliderContainer.appendChild(progressBar);
  
  const progressFill = progressBar.querySelector('.custom-card-progress-fill');
  
  // Update progress bar
  let progressInterval;
  
  function startProgress() {
    let progress = 0;
    const screenWidth = window.innerWidth;
    let delay = 2500; // Default - faster
    if (screenWidth <= 749) {
      delay = 3500; // Faster mobile
    } else if (screenWidth <= 1200) {
      delay = 3000; // Faster tablet
    }
    const step = 100 / (delay / 50);
    
    progressInterval = setInterval(() => {
      progress += step;
      if (progress >= 100) {
        progress = 0;
      }
      progressFill.style.width = progress + '%';
    }, 50);
  }
  
  function stopProgress() {
    clearInterval(progressInterval);
    progressFill.style.width = '0%';
  }
  
  // Store original functions and create wrappers
  window.customCardStartAutoScroll = function() {
    startFn();
    progressBar.classList.remove('paused');
    startProgress();
  };
  
  window.customCardStopAutoScroll = function() {
    stopFn();
    clearInterval(progressInterval);
    progressBar.classList.add('paused');
  };
}
